export const mutations = {
    SET_COLUMNS: (state, columns) => (state.columns = columns),
};
